import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {DateTimeFormatter} from './date-time-formatter';

const state = storeInstance.getState();

const dateTimeFormatter = new DateTimeFormatter(state[sdoNs.SESSION.locale]);

storeInstance.subscribe(() => {
  const state = storeInstance.getState();
  dateTimeFormatter.lang = state[sdoNs.SESSION].locale;
  dateTimeFormatter.cached = {};
});

export {
  dateTimeFormatter,
};
